import { render, staticRenderFns } from "./ProfileWidgetItem.vue?vue&type=template&id=08c07de8&scoped=true"
import script from "./ProfileWidgetItem.vue?vue&type=script&lang=js"
export * from "./ProfileWidgetItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileWidgetItem.vue?vue&type=style&index=0&id=08c07de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c07de8",
  null
  
)

export default component.exports